<template>
  <div>
    <b-button v-b-modal.add_news variant="primary" class="mb-3">
      <b-icon icon="file-plus" class="mr-2" />New Article
    </b-button>
    <b-modal
      ref="add_news"
      id="add_news"
      size="lg"
      title="New Article"
      @shown="focusTitle"
      @hide="hideModal"
    >
      <b-alert variant="danger" show v-if="isError"
        >An error occurred while submitting.</b-alert
      >
      <b-form-group label="Title">
        <b-form-input
          ref="focusThis"
          v-model="title"
          size="lg"
          placeholder="Enter article title"
        />
      </b-form-group>
      <b-form-group label="Type">
        <b-form-select v-model="article_type" size="md">
          <b-form-select-option
            v-for="(label, type) in article_types"
            :key="type"
            :value="type"
            >{{ label }}</b-form-select-option
          >
        </b-form-select>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="hideModal">Cancel</b-button>
        <b-button
          variant="success"
          class="mr-2"
          @click.prevent="submit()"
          :disabled="sending"
        >
          <b-spinner v-if="sending" small></b-spinner>
          <em v-else>
            <i class="fas fa-paper-plane"></i>
          </em>
          Next
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      title: "",
      sending: false,
      isError: false,
      article_type: null,
    };
  },
  computed: {
    ...mapGetters({
      article_types: "news/article_types",
    }),
  },
  created() {
    //console.log(this.article_types);
  },
  methods: {
    ...mapActions({
      createNews: "news/create",
      getArticleTypes: "news/fetchArticleTypes",
    }),
    submit() {
      this.sending = true;
      let vm = this;
      let article = {
        title: this.title, 
        type: this.article_type
      }
      this.createNews(article)
        .then((res) => {
          vm.hideModal();
          this.makeToast(
            "success",
            "Saved",
            "Article " + res.title + " has been saved!"
          );
          this.$router.push({
            name: "edit_news",
            params: { article_id: res.id },
          });
        })
        .catch((err) => {
          console.log(err);
          this.isError = true;
        })
        .then(() => {
          this.sending = false;
        });
    },
    focusTitle() {
      this.$refs.focusThis.focus();
    },
    hideModal() {
      this.$refs["add_news"].hide();
      this.isError = false;
      this.sending = false;
      this.title = "";
    },
  },
};
</script>

<style>
</style>